<mat-form-field appearance="outline">
  <mat-label>
    {{'view_value.month'|translate}}
  </mat-label>
  <input matInput [matDatepicker]="dp" [formControl]="date" />
  <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker
    #dp
    startView="multi-year"
    (monthSelected)="setMonthAndYear($event, dp)"
  >
  </mat-datepicker>
</mat-form-field>
